import { TripBookingTypes } from '../../lib/types/models/trip-booking/trip-booking'
import { UpdateInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function updateTripBooking(data: UpdateInput<TripBookingTypes.Input>) {
  const { id, ...rest } = data
  return restApiClient.url(constructApiUrl(API['trip-bookings'].update.url, { id })).patch(rest)
}

export const lockTripBooking = (id: number) => {
  return restApiClient.url(constructApiUrl(API['trip-bookings'].lock.url, { id })).post()
}

export const unlockTripBooking = (id: number) => {
  return restApiClient.url(constructApiUrl(API['trip-bookings'].unlock.url, { id })).post()
}

export const sendLockedTripBookingUpdateNotification = (data: {
  id: number
  emails: string[]
}) => {
  const { id, emails } = data
  return restApiClient
    .url(constructApiUrl(API['trip-bookings'].sendLockedUpdateNotification.url, { id }))
    .post({ emails })
}
